import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

const vueConfig = document.getElementById('vueconfig');
const config = JSON.parse(vueConfig.innerHTML);
const apiUrl = config.apiUrl;
const categorieId = config.categorieId;
const itemsPerPage = config.itemsPerPage;

Vue.use(Vuex)

//https://medium.com/@viplovemittal2/vuex-state-management-with-axios-post-api-calls-made-easy-c5fd67d88a2a

export default new Vuex.Store({
    state: {
        loadingStatus: 'notloading',
        categorieId: config.categorieId,
        filtertree: [],
        products: [],
        checkedFilter: {
            checkedBrands: [],
            checkedOpties: []
        },
        errors: [],
        currentPage: 1,
        itemsPerPage: itemsPerPage
    },
    mutations: {
        SET_LOADING_STATUS(state, payload) {
            state.loadingStatus = payload;
        },
        GET_CATEGORIES(state, payload) {
            state.filtertree = payload;
        },
        GET_PRODUCTS(state, payload) {
            state.products = payload;
        },
        CHANGE_CHECKEDBRANDS(state, payload) {
            state.checkedFilter.checkedBrands = payload;
        },
        CHANGE_CHECKEDOPTIES(state, payload) {
            state.checkedFilter.checkedOpties = payload;
        },
        ADD_ERROR(state, payload) {
            state.errors = [...state.errors, payload];
        },
        CHANGE_CURRENTPAGE(state, payload) {
            state.currentPage = payload;
        }
    },
    actions: {
        fetchCategories(context) {
            context.commit('SET_LOADING_STATUS', 'loading');
            axios.get(apiUrl + 'Categorie?CategorieID=' + categorieId)
                .then(result => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_CATEGORIES', result.data);
                })
                .catch(err => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_CATEGORIES', []);
                    context.commit('ADD_ERROR', err);
                })
        },
        fetchProducts(context, checkedFilter) {
            context.commit('SET_LOADING_STATUS', 'loading');
            /*let postFormData = new FormData();
            postFormData.set('categorieId', categorieId);
            postFormData.set('brands', checkedBrands);
            postFormData.set('opties', checkedOpties);*/
            axios.post(apiUrl + 'Products', {
                categorieId: categorieId,
                brands: checkedFilter.checkedBrands,
                opties: checkedFilter.checkedOpties,
                currentPage: this.state.currentPage,
                itemsPerPage: itemsPerPage
                })
                .then(result => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_PRODUCTS', result.data);
                })
                .catch(err => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_PRODUCTS', []);
                    context.commit('ADD_ERROR', err);
                })
        },
        changeCheckedBrands(context, value) {
            context.commit('CHANGE_CHECKEDBRANDS', value);
        },
        changeCheckedOpties(context, value) {
            context.commit('CHANGE_CHECKEDOPTIES', value);
        },
        changeCurrentPage(context, value) {
            context.commit('CHANGE_CURRENTPAGE', value);
            axios.post(apiUrl + 'Products', {
                categorieId: categorieId,
                brands: this.state.checkedFilter.checkedBrands,
                opties: this.state.checkedFilter.checkedOpties,
                currentPage: this.state.currentPage,
                itemsPerPage: itemsPerPage
                })
                .then(result => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_PRODUCTS', result.data);
                })
                .catch(err => {
                    context.commit('SET_LOADING_STATUS', 'notloading');
                    context.commit('GET_PRODUCTS', []);
                    context.commit('ADD_ERROR', err);
                })
           
        }
    }
})

